import React, { useRef, useState } from 'react'
import { ScoopCheckbox, ScoopMenu, ScoopMenuItem } from '../ui'
import { DotsThreeIcon } from '@phosphor-icons/react'
import styles from './WorksheetMetric.module.scss'

export const WorksheetMetric = ({
    chartState,
    setConfig,
    config,
    metricCol,
    handleWorksheetMetricSelect,
    selected,
}) => {
    const [open, setOpen] = useState(false)
    const anchor = useRef()

    const setSelectedColumnDate = (dateCol) => {
        const newConfig = { ...config }
        newConfig.selectedDates.set(
            config.worksheetID + ':' + metricCol.columnName,
            dateCol.columnName
        )
        chartState.getResults(newConfig)
        setConfig(newConfig)
    }

    return (
        <div className={styles.container}>
            <ScoopCheckbox
                checked={config.selectedItems.some((it) => it.measureName === metricCol.columnName)}
                onChange={() => handleWorksheetMetricSelect(metricCol)}
                size="md"
            />
            <span className={styles.metricName}>{metricCol.columnName}</span>
            {selected && config.worksheetColumns.some((col) => col.columnType === 'DateTime') && (
                <button
                    ref={anchor}
                    onClick={() => setOpen(true)}
                    className={styles.menuButton}
                    type="button"
                >
                    <DotsThreeIcon size={18} weight="bold" />
                </button>
            )}
            <ScoopMenu
                open={open}
                anchorEl={anchor.current}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {config.worksheetColumns
                    .filter((c) => c.columnType === 'DateTime')
                    .map((dateCol) => {
                        const selectedDate = config.selectedDates?.get(
                            config.worksheetID + ':' + metricCol.columnName
                        )
                        return (
                            <ScoopMenuItem
                                key={dateCol.columnName}
                                selected={selectedDate === dateCol.columnName}
                                onClick={() => {
                                    setSelectedColumnDate(dateCol)
                                    setOpen(false)
                                }}
                            >
                                by {dateCol.columnName}
                            </ScoopMenuItem>
                        )
                    })}
            </ScoopMenu>
        </div>
    )
}
